/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

window.PreAcceptModal = {
  initialize() {
    $('#skip-button').on('click', function() {
      const $form = $('#pre-accept-form');
      $form.find('input').removeAttr('required');
      $form.off('submit.Parsley');
      const input = $('<input />').attr('type', 'hidden').attr('name', 'choice').attr('value', 'accept_and_skip');
      $form.append(input);
      return $form.submit();
    });

    const telInput = document.querySelector('#contact-phone');
    if (telInput) {
      const iti = intlTelInput(telInput, {
        initialCountry: 'auto',
        nationalMode: false,
        separateDialCode: false,
        hiddenInput: 'signup[hidden_phone]',
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.2/js/utils.js',
        geoIpLookup(success, failure) {
          $.get('https://ipinfo.io', (function() {
          }), 'jsonp').always(function(resp) {
            const countryCode = resp && resp.country ? resp.country : '';
            success(countryCode);
          });
        }
      }
      );
    }

    return $('#pre-accept-form').parsley();
  }
};
